import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { ICampaignPayload } from "../types";

export const createCampaign = async (props: ICampaignPayload) => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/campaigns`;
  const { token, ...body } = props;
  return axios.post(
    url,
    body,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const useCreateCampaign = () => useMutation(createCampaign);
